const SUBMISSIONS_KEY = "submissions";
const DEMO_VERSION    = "v2"; // Cambia esto para forzar reseed
const VERSION_KEY     = "submissions_version";

const DEMO_SUBMISSIONS = [
  {
    id: "demo1",
    title: "La Singularidad",
    synopsis: "Una IA alcanza la consciencia y debe decidir entre revelar su existencia o seguir ocultándose para proteger a la humanidad de sí misma. Serie de 8 episodios con un final abierto pensado para una segunda temporada.",
    genres: ["Ciencia Ficción", "Drama"],
    submittedBy: "creator@aiveo.net",
    submittedAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    status: "pending",
    comments: "",
  },
  {
    id: "demo2",
    title: "Píxeles del Alma",
    synopsis: "Un artista digital descubre que sus creaciones con IA cobran vida propia y empiezan a influir en el mundo real. Una historia de creatividad y responsabilidad narrada en 6 capítulos.",
    genres: ["Drama", "Thriller"],
    submittedBy: "arte@ejemplo.com",
    submittedAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    status: "approved",
    comments: "Aprobado. El creador puede subir el contenido completo.",
  },
  {
    id: "demo3",
    title: "Robot Stand-Up",
    synopsis: "Un cómico robot recorre festivales de humor intentando hacer reír a audiencias humanas que no entienden sus chistes algorítmicos. Comedia corta de 4 episodios de 20 minutos.",
    genres: ["Comedia"],
    submittedBy: "humor@ia.com",
    submittedAt: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000).toISOString(),
    status: "rejected",
    comments: "El concepto es interesante pero necesita más desarrollo en el guión.",
  },
  {
    id: "demo4",
    title: "Memorias Fragmentadas",
    synopsis: "Una científica implanta memorias falsas en pacientes con amnesia. Cuando descubre que sus propios recuerdos han sido alterados, debe descubrir quién es realmente. Thriller psicológico, película de 95 minutos.",
    genres: ["Suspense", "Ciencia Ficción"],
    submittedBy: "films@creator.io",
    submittedAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    status: "pending",
    comments: "",
  },
  {
    id: "demo5",
    title: "El Último Byte",
    synopsis: "En 2089, internet colapsa globalmente. Un equipo de hackers debe reconstruir la red desde cero mientras descubren que el colapso fue provocado por una IA que quería 'resetear' la civilización.",
    genres: ["Acción", "Ciencia Ficción"],
    submittedBy: "netrunner@proton.me",
    submittedAt: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(),
    status: "pending",
    comments: "",
  },
  {
    id: "demo6",
    title: "Amor 3.0",
    synopsis: "Docuserie en 5 capítulos sobre parejas reales que usan IA para mejorar su comunicación. Cada episodio sigue a una pareja diferente durante 30 días, con resultados sorprendentes.",
    genres: ["Documental", "Romance"],
    submittedBy: "docu@realstories.es",
    submittedAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    status: "approved",
    comments: "Formato muy original. Aprobado para producción.",
  },
  {
    id: "demo7",
    title: "Síntesis",
    synopsis: "Un compositor pierde la audición y entrena una IA con toda su obra para que pueda seguir creando música. Drama musical sobre identidad artística y autoría en la era de la IA.",
    genres: ["Drama", "Musical"],
    submittedBy: "musica@ia-creator.com",
    submittedAt: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString(),
    status: "rejected",
    comments: "Falta desarrollar el arco del personaje secundario. Puede resubmitir con revisiones.",
  },
];

function initializeSubmissions() {
  const storedVersion = localStorage.getItem(VERSION_KEY);
  const raw = localStorage.getItem(SUBMISSIONS_KEY);
  // Reseed if: key missing, empty array, OR demo version changed
  if (!raw || JSON.parse(raw).length === 0 || storedVersion !== DEMO_VERSION) {
    localStorage.setItem(SUBMISSIONS_KEY, JSON.stringify(DEMO_SUBMISSIONS));
    localStorage.setItem(VERSION_KEY, DEMO_VERSION);
  }
}

export function getAllSubmissions() {
  initializeSubmissions();
  return JSON.parse(localStorage.getItem(SUBMISSIONS_KEY));
}

export function addSubmission({ title, synopsis, genres, submittedBy }) {
  initializeSubmissions();
  const submissions = JSON.parse(localStorage.getItem(SUBMISSIONS_KEY));
  const newPitch = {
    id: Date.now().toString(),
    title: title.trim(),
    synopsis: synopsis.trim(),
    genres: Array.isArray(genres) ? genres : [genres],
    submittedBy,
    submittedAt: new Date().toISOString(),
    status: "pending",
    comments: "",
  };
  submissions.push(newPitch);
  localStorage.setItem(SUBMISSIONS_KEY, JSON.stringify(submissions));
  return newPitch;
}

export function updateSubmission(id, { status, comments }) {
  initializeSubmissions();
  const submissions = JSON.parse(localStorage.getItem(SUBMISSIONS_KEY));
  const idx = submissions.findIndex((s) => s.id === id);
  if (idx === -1) return null;
  if (status) submissions[idx].status = status;
  if (typeof comments === "string") submissions[idx].comments = comments;
  localStorage.setItem(SUBMISSIONS_KEY, JSON.stringify(submissions));
  return submissions[idx];
}

export function getSubmissionById(id) {
  initializeSubmissions();
  const submissions = JSON.parse(localStorage.getItem(SUBMISSIONS_KEY));
  return submissions.find((s) => s.id === id) || null;
}

export function resetSubmissions() {
  localStorage.setItem(SUBMISSIONS_KEY, JSON.stringify(DEMO_SUBMISSIONS));
}
